export const ENCARGOS_CREACION_INICIALIZAR_REQUEST = 'ENCARGOS_CREACION_INICIALIZAR_REQUEST';
export const ENCARGOS_CREACION_INICIALIZAR_SUCCESS = 'ENCARGOS_CREACION_INICIALIZAR_SUCCESS';
export const ENCARGOS_CREACION_INICIALIZAR_FAILURE = 'ENCARGOS_CREACION_INICIALIZAR_FAILURE';

// Modificacion de atributos del encargo
export const ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA = 'ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA';
export const ENCARGOS_CREACION_ESTABLECER_CLIENTE = 'ENCARGOS_CREACION_ESTABLECER_CLIENTE';
export const ENCARGOS_CREACION_ELIMINAR_CLIENTE = 'ENCARGOS_CREACION_ELIMINAR_CLIENTE';
export const ENCARGOS_CREACION_ESTABLECER_GRADUACIONES = 'ENCARGOS_CREACION_ESTABLECER_GRADUACIONES';
export const ENCARGOS_CREACION_ESTABLECER_GRADUACION = 'ENCARGOS_CREACION_ESTABLECER_GRADUACION';

export const ENCARGOS_CREACION_MOSTRAR_GRADUACIONES = 'ENCARGOS_CREACION_MOSTRAR_GRADUACIONES';
export const ENCARGOS_CREACION_OCULTAR_GRADUACIONES = 'ENCARGOS_CREACION_OCULTAR_GRADUACIONES';

export const ENCARGOS_CREACION_BUSCAR_GRADUACION_REQUEST = 'ENCARGOS_CREACION_BUSCAR_GRADUACION_REQUEST';
export const ENCARGOS_CREACION_BUSCAR_GRADUACION_SUCCESS = 'ENCARGOS_CREACION_BUSCAR_GRADUACION_SUCCESS';
export const ENCARGOS_CREACION_BUSCAR_GRADUACION_FAILURE = 'ENCARGOS_CREACION_BUSCAR_GRADUACION_FAILURE';


export const ENCARGOS_CREACION_EXPANDIR_ENCARGO = 'ENCARGOS_CREACION_EXPANDIR_ENCARGO';
export const ENCARGOS_CREACION_CONTRAER_ENCARGO = 'ENCARGOS_CREACION_CONTRAER_ENCARGO';

// Selección de artículos
export const ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA = 'ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA';
export const ENCARGOS_CREACION_ARTICULOS_CREAR_ESTABLECER_A_LINEA = 'ENCARGOS_CREACION_ARTICULOS_CREAR_ESTABLECER_A_LINEA';
export const ENCARGOS_CREACION_SELECCIONAR_MONTURA_GAFA_GRADUADA = 'ENCARGOS_CREACION_SELECCIONAR_MONTURA_GAFA_GRADUADA';
export const ENCARGOS_CREACION_SET_GAFA_GRADUADA = 'ENCARGOS_CREACION_SET_GAFA_GRADUADA';
export const ENCARGOS_CREACION_ARTICULOS_TEMPORAL_CREAR_ESTABLECER_A_LINEA = 'ENCARGOS_CREACION_ARTICULOS_TEMPORAL_CREAR_ESTABLECER_A_LINEA';
export const ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA = 'ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA';
export const ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_REQUEST = 'ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_REQUEST';
export const ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_SUCCESS = 'ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_SUCCESS';
export const ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_FAILURE = 'ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_FAILURE';

export const ENCARGOS_CREACION_ARTICULOS_AÑADIR_A_LINEA_CON_FORMA = 'ENCARGOS_CREACION_ARTICULOS_AÑADIR_A_LINEA_CON_FORMA';
export const ENCARGOS_CREACION_ARTICULOS_BORRAR_LINEA = 'ENCARGOS_CREACION_ARTICULOS_BORRAR_LINEA';
export const ENCARGOS_CREACION_ARTICULOS_MODIFICAR_UNIDADES = 'ENCARGOS_CREACION_ARTICULOS_MODIFICAR_UNIDADES';
export const ENCARGOS_CREACION_ARTICULOS_AGREGAR_LINEA = 'ENCARGOS_CREACION_ARTICULOS_AGREGAR_LINEA';
export const ENCARGOS_CREACION_ARTICULOS_MODIFICAR_NUMERO_LOTE = 'ENCARGOS_CREACION_ARTICULOS_MODIFICAR_NUMERO_LOTE';

// Selección de artículos
export const ENCARGOS_CREACION_APLICAR_DESCUENTO = 'ENCARGOS_CREACION_APLICAR_DESCUENTO';
export const ENCARGOS_CREACION_BORRAR_DESCUENTO = 'ENCARGOS_CREACION_BORRAR_DESCUENTO';
export const ENCARGOS_CREACION_MODIFICAR_PRECIO_LINEA = 'ENCARGOS_CREACION_MODIFICAR_PRECIO_LINEA';

export const ENCARGOS_CREACION_APLICAR_ERRORES_FORMULARIO = 'ENCARGOS_CREACION_APLICAR_ERRORES_FORMULARIO';

// Guardado del encargo
export const ENCARGOS_CREACION_GUARDAR_REQUEST = 'ENCARGOS_CREACION_GUARDAR_REQUEST';
export const ENCARGOS_CREACION_GUARDAR_SUCCESS = 'ENCARGOS_CREACION_GUARDAR_SUCCESS';
export const ENCARGOS_CREACION_GUARDAR_FAILURE = 'ENCARGOS_CREACION_GUARDAR_FAILURE';
export const INICIAR_VENTANA_ADD_SUPLS = 'INICIAR_VENTANA_ADD_SUPLS';

export const OBTENER_FORMA_MONTURA_REQUEST = 'OBTENER_FORMA_MONTURA_REQUEST';
export const OBTENER_FORMA_MONTURA_SUCCESS = 'OBTENER_FORMA_MONTURA_SUCCESS';
export const OBTENER_FORMA_MONTURA_FAILURE = 'OBTENER_FORMA_MONTURA_FAILURE';
export const OBTENER_SUPLEMENTOS_LENTE_REQUEST = 'OBTENER_SUPLEMENTOS_LENTE_REQUEST';
export const OBTENER_SUPLEMENTOS_LENTE_SUCCESS = 'OBTENER_SUPLEMENTOS_LENTE_SUCCESS';
export const OBTENER_SUPLEMENTOS_LENTE_FAILURE = 'OBTENER_SUPLEMENTOS_LENTE_FAILURE';

export const ENCARGOS_CREACION_SET_LENTES = 'ENCARGOS_CREACION_SET_LENTES';
export const ENCARGOS_CREACION_SET_VISIBLE_VENTANA_ADD_SUPLS = 'ENCARGOS_CREACION_SET_VISIBLE_VENTANA_ADD_SUPLS';
